import { render, staticRenderFns } from "./BrowseCoursesSearch.vue?vue&type=template&id=72ec8d57&"
import script from "./BrowseCoursesSearch.vue?vue&type=script&lang=js&"
export * from "./BrowseCoursesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports